import React, { useState } from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { modelIdsTextV107 } from './channelCopyV107';
import './channelCopyV107.css';

export default function ChannelModelCopyV107({ modelIds, copyText, disabled, t }) {
  const [status, setStatus] = useState('');
  const fingerprint = modelIdsTextV107(modelIds);
  const [copiedFingerprint, setCopiedFingerprint] = useState('');
  const label = t('channel.edit.model_rules_v822.copy_all');
  const copyAll = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      const result = await copyText(fingerprint);
      setStatus(result === false ? 'copy_failed' : 'copied');
    } catch {
      setStatus('copy_failed');
    }
    setCopiedFingerprint(fingerprint);
  };
  return (
    <div className='channel-model-copy-v107'>
      <Popup
        content={label}
        trigger={
          <Button
            type='button'
            icon
            basic
            aria-label={label}
            title={label}
            disabled={disabled || !modelIds.length}
            onClick={copyAll}
          >
            <Icon name={status === 'copied' && copiedFingerprint === fingerprint ? 'check' : 'copy outline'} />
          </Button>
        }
      />
      <span className='channel-copy-status-v107' role='status'>
        {copiedFingerprint === fingerprint && status
          ? t(`channel.edit.model_rules_v822.${status}`)
          : ''}
      </span>
    </div>
  );
}
